var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmojiSmile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.5C7.30558 3.5 3.5 7.30558 3.5 12C3.5 16.6944 7.30558 20.5 12 20.5C16.6944 20.5 20.5 16.6944 20.5 12C20.5 7.30558 16.6944 3.5 12 3.5ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM8 9.5C8 8.80965 8.55965 8.25 9.25 8.25C9.94035 8.25 10.5 8.80965 10.5 9.5C10.5 10.1904 9.94035 10.75 9.25 10.75C8.55965 10.75 8 10.1904 8 9.5ZM13.5 9.5C13.5 8.80961 14.0597 8.25 14.75 8.25C15.4403 8.25 16 8.80961 16 9.5C16 10.1904 15.4403 10.75 14.75 10.75C14.0597 10.75 13.5 10.1904 13.5 9.5ZM8.64155 14.2981C8.93444 14.0052 9.40931 14.0052 9.70221 14.2981C10.9714 15.5673 13.0292 15.5673 14.2984 14.2981C14.5913 14.0052 15.0661 14.0052 15.359 14.2981C15.6519 14.591 15.6519 15.0658 15.359 15.3587C13.504 17.2137 10.4966 17.2137 8.64155 15.3587C8.34866 15.0658 8.34865 14.591 8.64155 14.2981Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiSmile);
export default __webpack_public_path__ + "static/media/emoji-smile.a911acb0b0f77ab9a7511c9a1a9bb44c.svg";
export { ForwardRef as ReactComponent };